import styled from '@emotion/styled'
import { useContext, useState } from 'react'
import { Flex } from 'rebass'

import Header from '../../components/Header'
import RulesModal from '../../components/RulesModal'
import CONST from '../../utils/const'
import { GameDifficultyContext } from '../../utils/GameModeContext'
import { getUpdatedScore, getResult, getSavedScore } from '../../utils/utility'
import ComputerChose from './ComputerChose/ComputerChose'
import ResultAnnounce from './ResultAnnounce/ResultAnnounce'
import ThumbChooser from './ThumbChooser/ThumbChooser'

const { GAME_STATE } = CONST

const GamePlayContainer = styled(Flex)`
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

const GameWorkingContainer = styled(Flex)`
  width: 100%;
  height: 70%;
  align-items: center;
  justify-content: center;
`

const initialState = {
  score: getSavedScore(),
  gameStage: GAME_STATE.PICK,
  userChose: '',
  computerChose: '',
  result: ''
}

const GamePlay = () => {
  const { difficulty } = useContext(GameDifficultyContext)
  const [state, setState] = useState(initialState)

  const handleUserChosen = (value) => {
    setState({
      ...state,
      gameStage: GAME_STATE.USER_PICKED,
      userChose: value
    })
  }

  const handleComputerChosen = (value) => {
    const userChose = state.userChose,
      computerChose = value,
      result = getResult(userChose, computerChose, difficulty)

    setState({
      ...state,
      computerChose: value,
      gameStage: GAME_STATE.RESULT,
      result,
      score: getUpdatedScore(state.score, result)
    })
  }

  const handlePlayAgain = () => {
    setState({
      ...initialState,
      score: getSavedScore()
    })
  }

  return (
    <GamePlayContainer>
      <Header score={state.score} />
      <GameWorkingContainer>
        {state.gameStage === GAME_STATE.PICK && <ThumbChooser onUserChosen={handleUserChosen} />}
        {state.gameStage === GAME_STATE.USER_PICKED && (
          <ComputerChose userChose={state.userChose} onComputerChosen={handleComputerChosen} />
        )}
        {state.gameStage === GAME_STATE.RESULT && (
          <ResultAnnounce
            userChose={state.userChose}
            computerChose={state.computerChose}
            result={state.result}
            onPlayAgainClick={handlePlayAgain}
          />
        )}
      </GameWorkingContainer>
      <Flex justifyContent="center">
        <RulesModal />
      </Flex>
    </GamePlayContainer>
  )
}

export default GamePlay
